module.exports = "/lucky-balls/img/bonus_green/check_infoBar/check_012.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/bonus_green/check_infoBar/check_012.png
// module id = 935
// module chunks = 0